import { FormControlStatus } from '@shared/model/form-control-status.enum';
import { map, OperatorFunction, shareReplay, startWith } from 'rxjs';
import { Ration, RationType } from '../model';
import { AnimalType } from '../model/animal-type.enum';
import { RationDetailsTabsConfig } from '../model/ration-details-tabs-config.model';
import { RationTab } from '../model/ration-tab.enum';

export const tabTitleMap: Map<RationTab, string> = new Map([
	[RationTab.Settings, 'sf.module.rations.my_rations.details.settings.title'],
	[RationTab.BasicData, 'sf.module.rations.my_rations.details.basic_data.title'],
	[RationTab.Ingredients, 'sf.module.rations.my_rations.details.ingredients.title'],
	[RationTab.Characteristics, 'sf.module.rations.my_rations.details.characteristics.title'],
	[RationTab.Analysis, 'sf.module.rations.my_rations.details.economic_analysis.title'],
]);

export const defaultAnimalType: AnimalType = AnimalType.DairyCattle;
export const averageLactationTime: number = 75;
export const averageLactationTimeMaxValue: number = 380;

export const releasedToFeedMixer = (ration: Ration): boolean => {
	return ration && Boolean(ration.feedMixerRelease);
};

export function formInvalidOperator(initStatus?: FormControlStatus): OperatorFunction<FormControlStatus, boolean> {
	return (source) => {
		return source.pipe(
			startWith(initStatus ? initStatus : FormControlStatus.VALID),
			map((status) => status !== FormControlStatus.VALID),
			shareReplay({
				bufferSize: 1,
				refCount: true,
			})
		);
	};
}

export const tabsConfig: RationDetailsTabsConfig = {
	tabs: [
		{
			tab: RationTab.Settings,
			title: 'sf.module.rations.my_rations.details.settings.title',
			types: [RationType.TMR, RationType.PMR],
		},
		{
			tab: RationTab.BasicData,
			title: 'sf.module.rations.my_rations.details.basic_data.title',
			types: [RationType.TMR, RationType.PMR],
		},
		{
			tab: RationTab.Ingredients,
			title: 'sf.module.rations.my_rations.details.ingredients.title',
			types: [RationType.TMR],
		},
		{
			tab: RationTab.FeedTableMilkingRobot,
			title: 'FeedTableMilkingRobot',
			types: [RationType.PMR],
		},
		{
			tab: RationTab.Characteristics,
			title: 'sf.module.rations.my_rations.details.characteristics.title',
			types: [RationType.TMR, RationType.PMR],
		},
		{
			tab: RationTab.TableOfFeeding,
			title: 'TableOfFeeding',
			types: [RationType.PMR],
		},
		{
			tab: RationTab.Analysis,
			title: 'sf.module.rations.my_rations.details.economic_analysis.title',
			types: [RationType.TMR, RationType.PMR],
		},
	],
};
